import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - ColdStorage`;
  }, [title]);
}

export default useTitle;
